<tt-page *ngIf="!!menu">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
            <tt-button-goto *ngIf="menu.floatingstock_is_updated === '0'" ttText="stockcountdata_new" ttGoto="stockcountdataitem" [ttGotoParms]="{ stockcountdataitem_keyno: '0', argtype: 'stock_keyno', argvalue: menu.stock_keyno }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list [ttData]="itemsListStockCountDatas"></tt-list>
    </div>

    <div class="col-xs-12 sp-0" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-4 p-5"  ttHeading="h_info">
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <div class="col-xs-12 col-md-4 p-5">
            <tt-card ttHeading="h_stock_count_data">
                <tt-button-goto *ngIf="menu.floatingstock_is_updated === '0'" ttText="stockcountdata_new" ttGoto="stockcountdataitem" [ttGotoParms]="{ stockcountdataitem_keyno: '0', argtype: 'stock_keyno', argvalue: menu.stock_keyno }" ttIcon="far fa-plus"></tt-button-goto>
            </tt-card>

            <tt-list [ttData]="itemsListStockCountDatas"></tt-list>
        </div>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!menu">
        <tt-textarea ttLabel="prodname_long" [ttModel]="menu.prodname_long" ttReadonly></tt-textarea>
        <tt-image *ngIf="menu.url_picture !== ''" ttLabel="picture" [ttSrc]="menu.url_picture"></tt-image>
        <tt-input-number ttLabel="stockvalue_stock" [ttModel]="menu.stockvalue_stock" ttTextAlign="right" ttFormatNumber ttDecimals="2" [ttButtons]="stockValueStockButtons" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="stockvalue_counted" [ttModel]="menu.stockvalue_counted" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="price" [ttModel]="menu.price" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input ttLabel="businessco_valuta_id" [ttModel]="menu.businessco_valuta_id" ttReadonly></tt-input>
        <tt-checkbox ttLabel="approved" [ttModel]="menu.approved" ttReadonly></tt-checkbox>
    </ng-container>
</ng-template>
